import { render, staticRenderFns } from "./PendingOrders.vue?vue&type=template&id=4e028856"
import script from "./PendingOrders.vue?vue&type=script&lang=js"
export * from "./PendingOrders.vue?vue&type=script&lang=js"
import style0 from "./PendingOrders.vue?vue&type=style&index=0&id=4e028856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports